import styled from '@emotion/styled';

export const MainBlock = styled.div`
  display: flex;
  gap: 10px;
`;

export const ScorerBlock = styled.div`
  display: flex;
  gap: 7px;
  align-items: center;

  max-width: 33%;
`;

export const Avatar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  width: 34px;
  min-width: 34px;
  height: 34px;
  min-height: 34px;
  border-radius: 4px;
  border: 0.5px solid ${({ theme }) => theme.colors.WhiteGray};

  & img {
    width: 34px;
    height: 34px;
    object-fit: contain;
  }
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;
